/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';

import { FlexCol, PlaceholderText, Placeholder } from 'sarsaparilla';

export default function ItemsPlaceholder() {
    return (
        <FlexCol xs={12}>
            <div className="rec-flex-card-wrap">
                <div className="rec-flex-card-image-wrap">
                    <Placeholder height="100px" />
                </div>

                <div className="rec-flex-card-content-wrap">
                    <div className="rec-flex-card-body-wrap">
                        <div className="mt-2 mb-1">
                            <PlaceholderText fontSize={20} lineHeight={20} width="15%" />
                        </div>
                        <PlaceholderText fontSize={30} lineHeight={35} width="50%" />
                        <PlaceholderText lines={2} />
                    </div>
                </div>
            </div>
        </FlexCol>
    );
}
